import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  useLazyGetTrackingForecastDetailedViewModelsQuery,
} from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';
import {
  selectCPMFTrackingForecastForecastDate,
  selectCPMFTrackingForecastLocationId,
  selectCPMFTrackingForecastSubpage,
  selectCPMFTrackingForecastTimeFrequency,
} from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { SUBPAGE_SUBMENU_OPTIONS } from 'types/Meteorology/Fields/TrackingForecast/DetailedView';

export default function useModelOptions() {
  // `currentData` (não `data`): ao trocar de aba, o `useLazyQuery` mantém em `data`
  // a lista do arg ANTERIOR durante o refetch do novo arg. Servir isso vazava os
  // modelos do modo antigo (ex.: os 20 do Multi-Locais sobre o Multi-Membros),
  // fazendo o modelId herdado passar na guarda e nunca ser re-selecionado (#1822).
  const [
    trigger, { currentData, isFetching },
  ] = useLazyGetTrackingForecastDetailedViewModelsQuery();

  const subpage = useSelector(selectCPMFTrackingForecastSubpage);
  const submenu = SUBPAGE_SUBMENU_OPTIONS[subpage];
  const timeFrequency = useSelector(selectCPMFTrackingForecastTimeFrequency);
  const locationId = useSelector(selectCPMFTrackingForecastLocationId);
  const forecastDate: string | undefined = useSelector(selectCPMFTrackingForecastForecastDate);

  const defaultFields = Boolean(submenu && timeFrequency);
  const multiModelFields = defaultFields && Boolean(locationId && forecastDate);

  const models = useMemo(() => {
    if (!currentData) return [];

    switch (submenu) {
      case 'multi-modelos': return multiModelFields ? currentData : [];
      default: return defaultFields ? currentData : [];
    }
  }, [currentData, submenu, defaultFields, multiModelFields]);

  useEffect(() => {
    switch (submenu) {
      case 'multi-modelos':
        if (multiModelFields) {
          trigger({
            submenu, timeFrequency, locationId, forecastDate,
          });
        }
        break;
      default:
        if (defaultFields) {
          trigger({ submenu, timeFrequency });
        }
        break;
    }
  }, [
    submenu, timeFrequency, defaultFields,
    locationId, forecastDate, multiModelFields,
    trigger,
  ]);

  return { models, isFetching };
}
